import { RegulatoryBoard } from '@/shell/services/regulatory'

export function RegulatoryCustomerPage() {
  return <RegulatoryBoard requestType="customer" />
}
